import store from '@/store';
import Vue from 'vue';
import AxiosService, { status } from '@/services/AxiosService';
import {
  START_LOADING,
  END_LOADING,
} from '@/store/mutation-types';

export default () => {
  const apiWrapper = {};

  function processData(data) {
    if (data && data.insert) {
      data.delete.forEach((object) => {
        store.dispatch('deleteObject', object);
      });
      data.insert.forEach((object) => {
        store.dispatch('saveObject', object);
      });
      data.update.forEach((object) => {
        const oldObject = store.getters.getObjectFromApi(object);
        if (oldObject) {
          oldObject.class = object.class;
          for (const property in object.changes) {
            oldObject[property] = object.changes[property][1];
          }
          store.dispatch('updateObject', oldObject);
        }
      });
    }
  }
  
  apiWrapper.post = function (url, data, inline = false, contentType = 'application/json') {
    let requestId = store.dispatch('startLoading');
    return AxiosService(inline, contentType)
      .post(url, data)
      .then((response) => {
        if (response.data.token) {
          store.dispatch(
            'setToken',
            {
              ...response.data,
            },
          );
        }
        processData(response.data);
        return response.data;
      })
      .catch((error) => { if (inline) return error; })
      .finally(() => { 
        store.dispatch('endLoading', requestId); 
      });
  };
  apiWrapper.put = function (url, data, inline = false, contentType = 'application/json') {
    let requestId = store.dispatch('startLoading');
    return AxiosService(inline, contentType)
      .put(url, data)
      .then((response) => {
        processData(response.data);
        return response.data;
      })
      .catch((error) => { if (inline) return error; })
      .finally(() => { 
        store.dispatch('endLoading', requestId);  
      });
  };
  apiWrapper.patch = function (url, data, inline = false) {
    let requestId = store.dispatch('startLoading');
    return AxiosService(inline)
      .patch(url, data)
      .then((response) => {
        processData(response.data);
        return response.data;
      })
      .catch((error) => { if (inline) return error; })
      .finally(() => { store.dispatch('endLoading', requestId); });
  };
  apiWrapper.delete = function (url, data, inline = false) {
    let requestId = store.dispatch('startLoading');
    return AxiosService(inline)
      .delete(url,  { data: data })
      .then((response) => {
        processData(response.data);
        return response.data;
      })
      .catch((error) => { if (inline) return error; })
      .finally(() => { store.dispatch('endLoading', requestId); });
  };
  apiWrapper.get = function (url, inline = false, loading = false , noEncoding = false) {
    let requestId = null;
    if (loading) {
      requestId = store.dispatch('startLoading');
    }
    return AxiosService(inline , null, noEncoding)
      .get(url)
      .then(response => response.data)
      .catch((error) => {
        if (inline) {
          return error;
        }
      })
      .finally(() => { if (loading) { store.dispatch('endLoading', requestId); } });
  };
  apiWrapper.status = status;
  apiWrapper.formData = (data) => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (Array.isArray(data[key])) {
        if (data[key].length > 0) {
          formData.append(key, data[key]);
        }
      } else if (data[key] || data[key] === false || data[key] === 0) {
        formData.append(key, data[key]);
      }
    });
    return formData;
  };

  apiWrapper.formDataNone = (data) => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (Array.isArray(data[key])) {
        if (data[key].length > 0) {
          formData.append(key, data[key]);
        }
      } else {
        formData.append(key, data[key]);
      }
    });
    return formData;
  };

  return apiWrapper;
};
